import Container from "../components/core/Container";
import Paragraph from "../components/core/Paragraph";
import Heading from "../components/core/Heading";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Link from "../components/core/Link";

const NotFoundPage = () => {
    return (
        <>
            <Nav />
            <Container className="min-h-screen flex flex-col justify-center items-center">
                <Heading variant="h1">404 - Stránka nebyla nalezena</Heading>
                <Paragraph variant="lead_black">Stránka, na kterou jste se snažili přejít, nebyla nalezena. Můžete se vrátit na <Link to="/">hlavní stránku</Link>.</Paragraph>
            </Container>
            <Footer />
        </>
    );
};

export default NotFoundPage;